import React from 'react';
import { Typography } from 'antd';
import styles from './index.module.scss';

export default function PageHeader({ title }: {title: string}) {
  return (
    <Typography.Title level={4} className={styles.pageHeader}>{title}</Typography.Title>
  );
}
